import styled from 'styled-components';

import { transparentize } from '@savgroup-front-common/primitive/helpers/cssColor';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $DropdownSuggestions = styled('div')`
  background-color: ${({ theme }) => theme.colors.white};
  border-style: solid;
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  border-color: ${({ theme }) => theme.colors.default};
  border-width: ${({ theme }) => theme.borders.thickness};
  ${({ theme }) => theme.shadows.elevation__2};
  margin-top: ${spacing('xxs')};
  z-index: 2;
  position: absolute;
  width: 100%;
`;

export const $Suggestion = styled('div')<{ active: boolean }>`
  color: ${({ theme }) => theme.colors.mainTextColor};
  background-color: ${({ theme, active }) =>
    active ? transparentize(0.85, theme.colors.default) : theme.colors.white};
  padding: ${spacing(3.5)};
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) =>
      transparentize(0.85, theme.colors.default)};
  }
`;
